export class RaceViewModel
{
  Id: number = 0;
  Name: string = "";
  ContactName: string = "";
  Location: string = "";
  Url: string = "";
  Type: string = "Bike";
  Distance: number = 0;
  From: number = new Date().getTime();
  Till: number = new Date().getTime();
  Editable: boolean = false;
  Participate: boolean = false;
  Image: string;

  init(data?: any): void
  {
    if (data)
    {
      this.Id = data["id"];
      this.Name = data["name"];
      this.ContactName = data["contactName"];
      this.Location = data["location"];
      this.Url = data["url"];
      this.Type = data["type"];
      this.From = data["from"];
      this.Till = data["till"];
      this.Distance = data["distance"];
      this.Editable = data["editable"];
      this.Participate = data["participate"];
    }
  }

  static fromJS(data: any): RaceViewModel
  {
    let result = new RaceViewModel();
    result.init(data);
    return result;
  }
}
